<template>

    <div v-if="renderButtons">
        <social-sharing :url="url"
                        :title="title"
                        :description="description"
                        :networks="overriddeNetworks"
                        inline-template>
                    <ul class="socials">
                        <li>
                            <network network="email">
                                <a @click.prevent>
                                    <social-icon social="fas fa-envelope" altText="Email Icon"/>
                                </a>
                            </network>
                        </li>
                        <li>
                            <network network="facebook">
                                <a @click.prevent>
                                    <social-icon social="fab fa-facebook-f" altText="Facebook Icon"/>
                                </a>
                            </network>
                        </li>
                        <li>
                            <network network="twitter">
                                <a @click.prevent>
                                    <social-icon social="fab fa-twitter" altText="Twitter Icon"/>
                                </a>
                            </network>
                        </li>                        <li>
                            <network network="linkedin">
                                <a @click.prevent>
                                    <social-icon social="fab fa-linkedin-in" altText="Linkedin Icon"/>
                                </a>
                            </network>
                        </li>
                    </ul>
        </social-sharing>
    </div>
</template>

<script>
    export default {
        name: "ShareButtons",
        data: () => ({
            renderButtons: false
        }),
        computed: {

            url: {
                get: function () {
                    return window.social_share_post_data.post_url
                }
            },
            title: {
                get: function () {
                    return this.replaceHTML(window.social_share_post_data.post_title)
                }

            },
            description: {
                get: function () {
                    return this.replaceHTML(this.sliceExcerpt(window.social_share_post_data.post_excerpt))
                }
            },
        },
        mounted() {
        },
        created() {
            this.renderButtons = !!window.social_share_post_data;
        },
        methods: {
            sliceExcerpt(excerpt) {
                // Slice the <p> from beginning and end of description for FB
                return excerpt.slice(3, excerpt.length - 5);
            },
            replaceHTML(string) {
                string = string.replace(/&#8216;/g, "'"); //Beginning quote
                string = string.replace(/&#8217;/g, "'"); //Apostrophe
                string = string.replace(/&#8220;/g, "\""); // First double quote
                string = string.replace(/&#8221;/g, "\""); // Second double quote
                string = string.replace(/&#8211;/g, "-"); // en dash
                string = string.replace(/&#8212;/g, "–"); // em dash
                string = string.replace(/&#224;/g, "à"); // a with grave
                string = string.replace(/&#225;/g, "á"); // a with acute
                string = string.replace(/&#232;/g, "è"); // e with grave
                string = string.replace(/&#233;/g, "é"); // e with acute
                string = string.replace(/&#234;/g, "ê"); // e with circumflex
                string = string.replace(/&#038;/g, "&"); // Ampersand
                return string;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ShareButtons.vue